/* eslint-disable react/require-default-props */
/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { TabView } from '@ui';`
 *
 * Or specific path: `import { TabView } from '@ui/molecules/TabView';`
 *
 * See the new component for documentation and migration notes.
 */
import React, { useState, useEffect } from 'react';
export default function TabView({ tabs, initialTabId, onTabChange, tabSelected, navClassName = 'workspace__tabs nav', navLinkClassName = 'tabs__option', tabContentClassName = 'workspace__tab-container tab-content', activeTabClassName = 'active', activeNavLinkClassName = 'active' }) {
    const [activeTab, setActiveTab] = useState(() => {
        if (tabSelected)
            return tabSelected;
        if (initialTabId)
            return initialTabId;
        return tabs.length > 0 ? tabs[0].id : '';
    });
    useEffect(() => {
        if (tabSelected) {
            setActiveTab(tabSelected);
        }
    }, [tabSelected]);
    const handleTabClick = (tabId, e) => {
        e.preventDefault();
        setActiveTab(tabId);
        if (onTabChange) {
            onTabChange(tabId);
        }
    };
    if (!tabs || tabs.length === 0) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: navClassName }, tabs.map((tab) => (React.createElement("li", { key: tab.id, className: activeTab === tab.id ? activeNavLinkClassName : '' },
            React.createElement("a", { href: `#${tab.id}`, "data-toggle": "tab", className: navLinkClassName, onClick: (e) => handleTabClick(tab.id, e), "aria-current": activeTab === tab.id ? 'page' : undefined }, tab.label))))),
        React.createElement("div", { className: tabContentClassName }, tabs.map((tab) => (React.createElement("article", { key: tab.id, className: `workspace__tab-pane tab-pane ${activeTab === tab.id ? activeTabClassName : ''}`, id: tab.id, role: "tabpanel", hidden: activeTab !== tab.id }, activeTab === tab.id && tab.content))))));
}
